module.exports = __webpack_public_path__ + "img/SKMJ_sky5.32b7d74b.jpg";